import { generateTypes } from '../utils/HttpReducerHelper';

const REQUEST_VERIFY_COMPANY_NAME = 'platfi-ui-app/TEAMS/REQUEST_VERIFY_COMPANY_NAME';
const REQUEST_VERIFY_EMAIL_EXISTS = 'platfi-ui-app/TEAMS/REQUEST_VERIFY_EMAIL_EXISTS';
const REQUEST_VERIFY_MULTIPLE_EMAIL_EXISTS =
  'platfi-ui-app/TEAMS/REQUEST_VERIFY_MULTIPLE_EMAIL_EXISTS';
const REQUEST_VERIFY_TEAM_NAME = 'platfi-ui-app/TEAMS/REQUEST_VERIFY_TEAM_NAME';
const myTeam = generateTypes('TEAMS', 'MY_TEAM');
const myNetwork = generateTypes('TEAMS', 'MY_NETWORK');
const myCompany = generateTypes('TEAMS', 'MY_COMPANY');
const editTeam = generateTypes('TEAMS', 'EDIT_TEAM');
const viewTeam = generateTypes('TEAMS', 'VIEW_TEAM');
const SET_TEAM_MEMBERS = 'platfi-ui-app/TEAMS/SET_TEAM_MEMBERS';
const SET_TEAM = 'platfi-ui-app/TEAMS/SET_TEAM';
const SET_COMPANY = 'platfi-ui-app/TEAMS/SET_COMPANY';

export * from './updateRole/types';
export * from './myCompanyTeams/types';
export * from './resendInvite/types';
export * from './makeChampion/types';

export {
  REQUEST_VERIFY_COMPANY_NAME,
  REQUEST_VERIFY_EMAIL_EXISTS,
  REQUEST_VERIFY_MULTIPLE_EMAIL_EXISTS,
  REQUEST_VERIFY_TEAM_NAME,
  myTeam,
  myNetwork,
  myCompany,
  editTeam,
  SET_TEAM_MEMBERS,
  SET_TEAM,
  SET_COMPANY,
  viewTeam,
};
